import { render, staticRenderFns } from "./ShareLinkDialog.vue?vue&type=template&id=efc63472&"
import script from "./ShareLinkDialog.vue?vue&type=script&lang=js&"
export * from "./ShareLinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShareLinkDialog.vue?vue&type=style&index=0&id=efc63472&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports